import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	board: {
		id: 'spa-apps-sidebar-common.scope-switcher.board',
		defaultMessage: 'Board',
		description: 'Scope Switcher board description',
	},
});
